module.exports = __webpack_public_path__ + "x4.no1.1fc4e14c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/x4.no1.jpg
// module id = 2Ele
// module chunks = 0